import type { PdfCrop } from '../types/pdfCrop'

/** Source report — all Boehringer imagery in the deck is cropped live from this PDF. */
export const BOEHRINGER_REPORT_PDF =
  'https://cdn.magicpatterns.com/uploads/r6zgDFs1mnB13mFLp5U9n8/Boehringer_T2D_CVD_Report_060525.pdf'

/** The live Boehringer Snak. */
export const BOEHRINGER_SNAK_URL =
  'https://player.snakker.io/review/RSppqWXvABzUr6js_dEc'

/** Report pages are 16:9 slides. */
export const PDF_PAGE_ASPECT = 16 / 9

export const boehringerImages = {
  /** Page 1 — GP and patient in a greenhouse, with brand green blocks. */
  coverPhoto: { page: 1, x: 0.549, y: 0.118, w: 0.429, h: 0.849 },
  /** Page 3 — full email layout with subject line and .gif. */
  emailFull: { page: 3, x: 0.472, y: 0.037, w: 0.505, h: 0.958 },
  /** Page 5 — aggregated Snak metrics grid. */
  metricsGrid: { page: 5, x: 0.054, y: 0.311, w: 0.896, h: 0.653 },
  /** Page 6 — individual Snak screens from the user journey. */
  emailThumb: { page: 6, x: 0.032, y: 0.315, w: 0.131, h: 0.194 },
  statScreen: { page: 6, x: 0.429, y: 0.315, w: 0.175, h: 0.192 },
  quizScreen: { page: 6, x: 0.661, y: 0.315, w: 0.19, h: 0.192 },
  correctScreen: { page: 6, x: 0.034, y: 0.645, w: 0.195, h: 0.198 },
  doubtScreen: { page: 6, x: 0.264, y: 0.645, w: 0.176, h: 0.198 },
  ctaScreen: { page: 6, x: 0.486, y: 0.645, w: 0.185, h: 0.198 },
  loginPage: { page: 6, x: 0.755, y: 0.611, w: 0.143, h: 0.132 },
  kiapPage: { page: 6, x: 0.755, y: 0.85, w: 0.142, h: 0.139 },
  /** Page 7 — answer breakdown and insight cards. */
  quizResults: { page: 7, x: 0.077, y: 0.541, w: 0.21, h: 0.427 },
  journeyInsights: { page: 7, x: 0.014, y: 0.305, w: 0.968, h: 0.665 },
} satisfies Record<string, PdfCrop>
